var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"aria-labelledby":_vm.name + '-title'}},[_c('use',{attrs:{"xlink:href":`${_vm.$contextPath}${_vm.sprite}#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }